import { frApiURL } from '@core/Environment/Variables';
import { fetchJson } from '@core/Utils/Fetch/FetchJson';
import type { AutoCompleteOptionProps } from '@gds/Autocomplete/Components/AutocompleteOption.types';

import type { RegionsResponse } from 'Components/Plp/Filters/Components/LocationFilter/LocationFilter.entity';

const getRegionsOptions = async (): Promise<AutoCompleteOptionProps[] | undefined> => {
  try {
    const data = await fetchJson<RegionsResponse>(`${frApiURL}/location/nuts`);

    if (data) {
      const { nuts1Regions } = data;

      return nuts1Regions.flatMap(i => {
        const items = {
          value: JSON.stringify({ 'nuts1-code': i.code, 'nuts-label': i.name }),
          label: i.name,
          id: i.code,
        };
        return items;
      });
    }
  } catch (_error) {
    return [];
  }
};

export default getRegionsOptions;
